/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CheckAgentPolicyGrantsForm,
  CheckAgentPolicyGrantsForm$Outbound,
  CheckAgentPolicyGrantsForm$outboundSchema,
} from "../components/checkagentpolicygrantsform.js";

export type CheckAgentPolicyGrantsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CheckAgentPolicyGrantsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  checkAgentPolicyGrantsForm: CheckAgentPolicyGrantsForm;
};

/** @internal */
export type CheckAgentPolicyGrantsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CheckAgentPolicyGrantsSecurity$outboundSchema: z.ZodMiniType<
  CheckAgentPolicyGrantsSecurity$Outbound,
  CheckAgentPolicyGrantsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function checkAgentPolicyGrantsSecurityToJSON(
  checkAgentPolicyGrantsSecurity: CheckAgentPolicyGrantsSecurity,
): string {
  return JSON.stringify(
    CheckAgentPolicyGrantsSecurity$outboundSchema.parse(
      checkAgentPolicyGrantsSecurity,
    ),
  );
}

/** @internal */
export type CheckAgentPolicyGrantsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CheckAgentPolicyGrantsForm: CheckAgentPolicyGrantsForm$Outbound;
};

/** @internal */
export const CheckAgentPolicyGrantsRequest$outboundSchema: z.ZodMiniType<
  CheckAgentPolicyGrantsRequest$Outbound,
  CheckAgentPolicyGrantsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    checkAgentPolicyGrantsForm: CheckAgentPolicyGrantsForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      checkAgentPolicyGrantsForm: "CheckAgentPolicyGrantsForm",
    });
  }),
);

export function checkAgentPolicyGrantsRequestToJSON(
  checkAgentPolicyGrantsRequest: CheckAgentPolicyGrantsRequest,
): string {
  return JSON.stringify(
    CheckAgentPolicyGrantsRequest$outboundSchema.parse(
      checkAgentPolicyGrantsRequest,
    ),
  );
}
